import './surveySelection.css';
import React, { useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import { useParams } from 'react-router-dom';
import commonService from '../../features/common/commonService';
import Spinner from '../Layout/Spinner';
import { toast } from 'react-toastify';


function SurveySelection(props) {
    let { urlcode } = useParams();
    let [surveyData, setSurveyData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const surveys = [];

    const [surveyFilterVar, setSurveyFilterVar] = useState('')

    const onSurveySelect = (event) => {
        setSurveyFilterVar(event);
    };

    useEffect(() => {
        document.title = props.title

        setIsLoading(true)
        commonService.getSurveySelection(urlcode).then((result) => {
            console.log(result)
            setSurveyData(result);
            setIsLoading(false)

        }).catch((err) => {
            toast.error(err.message ? err.message : "Unable to fetch survey data.");
            setIsLoading(false)

        })

    },[])


    // const clickTakeSurvey = () => {
    //     if(surveyFilterVar){
    //     debugger
    //         let surveyFilter = surveyData.surveyData.find((val, key) => {
    //             return val.surveyId.shortCode == surveyFilterVar
    //         });
    //         console.log("surveyFilter :" +surveyFilter);
    //         if(surveyFilter.closeData == 1){
    //             toast.error("This survey is closed and no longer accepts responses.")
    //         } else {
    //             window.open(`https://westedk12enterprise.co1.qualtrics.com/jfe/form/${surveyFilter.qualtricsId}?westID=${surveyFilter.westedID}`, '_blank');
    //         }
    //     } else {
    //         toast.error("Please select survey");
    //     }
    // }

    const clickTakeSurvey = () => {
        if (surveyData && surveyData.surveyData && surveyData.surveyData.length > 0 && surveyData.districtData.surveyRegSubmitAt != null) {
            let surveyFilter = surveyData.surveyData[0];  // Directly using the first survey
            if (surveyFilter.closeData == 1) {
                toast.error("This survey is closed and no longer accepts responses.");
            } else {
                window.open(`https://westedk12enterprise.co1.qualtrics.com/jfe/form/${surveyFilter.qualtricsId}?westID=${surveyFilter.westedID}`, '_blank');
            }
        } else {
            toast.error("No survey data available.");
        }
    };


    return (
        <>
              {(isLoading === true) ? <Spinner></Spinner> : ""}

            <div className='surSel_pageContent'>
                <div className="code_topImageHeader">
                    <span><img alt="Logo" src={require("../../assets/images/CalSCHLS_Logo_No_Tag_Gold_Blue.png")} className="code_logoSize"></img></span>
                    <span><img alt="Wested Logo" src={require("../../assets/images/WestEd_Survey_logo.png")} className="code_westedLogo"></img></span>
                    <span><img alt="California Department of Education (CDE) logo" src={require("../../assets/images/seal.png")} className="code_cdeLogo"></img></span>
                    <span><img alt="California Department of Health Care Services (DHCS) logo" src={require("../../assets/images/DHCS-logo-official.png")} className="code_dhcsLogo"></img></span>
                </div>
                <h1 className="code_schoolSurvey">
                   {surveyData && surveyData.headerTitle ? surveyData.headerTitle : ''}
                </h1>
                <h2 className="code_schoolType code_darkbackground">
                {surveyData ? surveyData.schoolName : ''}
                </h2>
                {/* <div className="code_selectSurvey">
                    <FormControl className="code_FilterDrop" variant="standard" sx={{ m: 0, minWidth: 230 }}>
                        <InputLabel id="demo-simple-select-standard-label">Please select Survey</InputLabel>
                        <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            value={surveyFilterVar}
                            onChange={(e) => onSurveySelect(e.target.value)}
                            label="Please select Survey">
                            <MenuItem value='' >
                                SELECT SURVEY
                            </MenuItem>
                            {surveyData && surveyData.surveyData && surveyData.surveyData.map((survey, key) => (
                            <MenuItem key={key} value={survey.surveyId.shortCode}>
                                {survey.surveyId.name}
                            </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div> */}
                <div className="code_warning">
                Please confirm this is your school before proceeding with the survey.<br /><span lang="es">Por favor confirma que esta es tu escuela antes de continuar con la encuesta.</span>
                </div>
                <div className="code_surveyButton">
                    <Button id="takeSurveyBtn" variant="contained" size="small" className="code_takeSurveyBtn" onClick={clickTakeSurvey}> TAKE SURVEY </Button>
                </div>
            </div>
        </>
    )
}

export default SurveySelection